import AppConfig from "../AppConfig.json";
export const appConfig = AppConfig;



// WEBPACK FOOTER //
// ./src/config/initializers/config.app.js